/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the styles used by the attributes and values cells ...
export const useStyles = makeStyles((theme: DLSTheme) => ({
  memberCount : {
    position   : 'relative',
    padding    : 0,
    fontSize   : '12px',
    lineHeight : '20px'
  },
  memberList : {
    listStyleType : 'none'
  }
}));

export const GroupsItemCountCell = (data) => {
  const classes   =   useStyles();
  const members   =   data?.value?.split(',') || [];
  return (
    <ul className={classes.memberCount}>
      {members.map((member, index) => (
        <li key={`member_${index}`} className={classes.memberList}>{member}</li>
      ))}
    </ul>
  );
};
